import { ThemeEvents } from '@theme/events';

// Tauscht das Galeriebild gegen das Bild der gewählten Sorte.
//
// Die Sorte ist eine Line-Item-Property, keine Variante — Horizon weiß von ihr
// nichts und rendert deshalb auch kein passendes Bild. Getauscht wird nur das
// <img> im vorhandenen Slide, nie die Galerie-Struktur: die gehört
// slideshow-component, und ein Eingriff dort kollidiert mit deren Zustand.
//
// Der Rückweg ist Pflicht: ohne gespeichertes Ausgangsbild bliebe die zuletzt
// gewählte Sorte stehen, sobald jemand die Auswahl zurücksetzt.
class MkPropertyImage extends HTMLElement {
  #select = null;
  #image = null;
  #original = null;

  connectedCallback() {
    this.#select = this.querySelector('select[data-mk-property-image]');
    if (!this.#select) return;

    // Die Galerie ist ein GESCHWISTER der Kaufspalte, nicht ihr Kind — deshalb
    // ab der Section suchen, nicht ab diesem Element.
    const section = this.closest('.shopify-section') ?? document;
    this.#image = section.querySelector('media-gallery [ref="slides[]"] img, media-gallery .product-media img');
    if (!this.#image) return;

    this.#original = { src: this.#image.src, srcset: this.#image.srcset, alt: this.#image.alt };
    this.#select.addEventListener('change', this.#swap);
    // Ein Variantenwechsel lässt die Galerie ihr Bild fresh setzen — danach muss die
    // getroffene Sorte wieder greifen. Der Ereignisname kommt aus Horizon
    // (`variant:update`); ihn hier abzuschreiben hieße, ihn beim nächsten Umbenennen
    // still zu verlieren.
    section.addEventListener(ThemeEvents.variantUpdate, this.#follow);
  }

  disconnectedCallback() {
    this.#select?.removeEventListener('change', this.#swap);
    (this.closest('.shopify-section') ?? document).removeEventListener(ThemeEvents.variantUpdate, this.#follow);
  }

  #swap = () => {
    const opt = this.#select.selectedOptions[0];
    const url = opt?.dataset.mkImage;
    if (!this.#image || !this.#original) return;
    if (!url) {
      Object.assign(this.#image, this.#original);
      return;
    }
    // srcset leeren, sonst gewinnt der alte Kandidatensatz gegen das neue src.
    this.#image.srcset = '';
    this.#image.src = url;
    this.#image.alt = opt.dataset.mkImageAlt || opt.textContent.trim();
  };

  #follow = () => {
    // Erst muss die Galerie ihr eigenes Update fertig haben — beide hängen am selben
    // Ereignis, und wer zuerst läuft, entscheidet sonst die Registrierungsreihenfolge.
    requestAnimationFrame(() => this.#restore());
  };

  #restore = () => {
    // Nach dem Re-Render ist das <img> ein anderes Element.
    const section = this.closest('.shopify-section') ?? document;
    const fresh = section.querySelector('media-gallery [ref="slides[]"] img, media-gallery .product-media img');
    if (fresh && fresh !== this.#image) {
      this.#image = fresh;
      this.#original = { src: fresh.src, srcset: fresh.srcset, alt: fresh.alt };
    }
    this.#swap();
  };
}

if (!customElements.get('mk-property-image')) {
  customElements.define('mk-property-image', MkPropertyImage);
}
